import type { ReactNode } from 'react';

export interface StatCardProps {
  label: string;
  value: ReactNode;
  /** 아이콘/이모지 */
  icon?: ReactNode;
  /** 보조 설명 (예: "오늘", 증감) */
  hint?: ReactNode;
}

/** 대시보드 단일 지표 카드 */
export default function StatCard({ label, value, icon, hint }: StatCardProps) {
  return (
    <div className="stat-card">
      <span className="stat-card__label">
        {icon && <span aria-hidden>{icon}</span>}
        {label}
      </span>
      <span className="stat-card__value">{value}</span>
      {hint && <span className="stat-card__hint">{hint}</span>}
    </div>
  );
}
